import { FC, useState } from 'react';
import { motion, AnimatePresence } from 'motion/react'
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from 'react-icons/md';

import {
  AccordianProps,
  AccordianItemProps,
  AccordianItemType,
  Styled,
} from './';

const Accordian: FC<AccordianProps> = ({ items }) => {
  return (
    <Styled.AccordianContainer>
      {items.map((item: AccordianItemType) => {
        if (item.description.length > 0) {
          return <AccordianItem item={item} key={item.title} />;
        }
      })}
    </Styled.AccordianContainer>
  );
};

const AccordianItem: FC<AccordianItemProps> = ({ item }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(
    item.isExpanded ? item.isExpanded : false
  );
  return (
    <Styled.AccordianItemContainer>
      <Styled.AccordinHeader onClick={() => setIsExpanded(!isExpanded)}>
        <Styled.Title>{item.title}</Styled.Title>
        {isExpanded ? (
          <MdKeyboardArrowDown size={'24px'} />
        ) : (
          <MdKeyboardArrowRight size={'24px'} />
        )}
      </Styled.AccordinHeader>
      <AnimatePresence initial={false}>
        {isExpanded && (
          <motion.section
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              collapsed: { opacity: 0, height: 0 },
            }}
            transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            <Styled.AccordianBody
              dangerouslySetInnerHTML={{
                __html: item.description,
              }}
            ></Styled.AccordianBody>
          </motion.section>
        )}
      </AnimatePresence>
    </Styled.AccordianItemContainer>
  );
};

export default Accordian;
